var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDropdownField(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.16663 3.95312H4.99996C5.663 3.95312 6.29889 4.21652 6.76773 4.68536C7.23657 5.1542 7.49996 5.79008 7.49996 6.45312C7.49996 5.79008 7.76335 5.1542 8.23219 4.68536C8.70103 4.21652 9.33692 3.95313 9.99996 3.95312H10.8333",
    stroke: "#67768E",
    strokeWidth: 1.1983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 17.2891H9.99996C9.33692 17.2891 8.70103 17.0257 8.23219 16.5568C7.76335 16.088 7.49996 15.4521 7.49996 14.7891C7.49996 15.4521 7.23657 16.088 6.76773 16.5568C6.29889 17.0257 5.663 17.2891 4.99996 17.2891H4.16663",
    stroke: "#67768E",
    strokeWidth: 1.1983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.16663 13.9557H3.33329C2.89127 13.9557 2.46734 13.7801 2.15478 13.4676C1.84222 13.155 1.66663 12.7311 1.66663 12.2891V8.95573C1.66663 8.5137 1.84222 8.08978 2.15478 7.77722C2.46734 7.46466 2.89127 7.28906 3.33329 7.28906H4.16663",
    stroke: "#67768E",
    strokeWidth: 1.1983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8334 7.28906H16.6667C17.1087 7.28906 17.5327 7.46466 17.8452 7.77722C18.1578 8.08978 18.3334 8.5137 18.3334 8.95573V12.2891C18.3334 12.7311 18.1578 13.155 17.8452 13.4676C17.5327 13.7801 17.1087 13.9557 16.6667 13.9557H10.8334",
    stroke: "#67768E",
    strokeWidth: 1.1983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 6.45312V14.7865",
    stroke: "#67768E",
    strokeWidth: 1.1983,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownField);
export default __webpack_public_path__ + "static/media/DropdownField.6f7bb13355c1f69aaa2c0c2c2751da6c.svg";
export { ForwardRef as ReactComponent };